import { Actions } from './document-types.actions'
import { fromJS } from 'immutable'
import * as DocumentTypesTypes from './document-types.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  createDocumentType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateDocumentType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function documentTypesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case DocumentTypesTypes.UPDATE_DOCUMENT_TYPE_REQUEST: {
      return state.setIn(['updateDocumentType', 'isLoading'], true)
    }

    case DocumentTypesTypes.UPDATE_DOCUMENT_TYPE_SUCCESS: {
      return state.setIn(['updateDocumentType', 'isLoading'], false)
    }

    case DocumentTypesTypes.UPDATE_DOCUMENT_TYPE_FAILURE: {
      return state.setIn(['updateDocumentType', 'isLoading'], false)
    }

    case DocumentTypesTypes.CREATE_DOCUMENT_TYPE_REQUEST: {
      return state.setIn(['createDocumentType', 'isLoading'], true)
    }

    case DocumentTypesTypes.CREATE_DOCUMENT_TYPE_SUCCESS: {
      return state.setIn(['createDocumentType', 'isLoading'], false)
    }

    case DocumentTypesTypes.CREATE_DOCUMENT_TYPE_FAILURE: {
      return state.setIn(['createDocumentType', 'isLoading'], false)
    }

    case DocumentTypesTypes.DELETE_DOCUMENT_TYPE_REQUEST: {
      return state
    }

    case DocumentTypesTypes.DELETE_DOCUMENT_TYPE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case DocumentTypesTypes.DELETE_DOCUMENT_TYPE_FAILURE: {
      return state
    }

    case DocumentTypesTypes.FETCH_DOCUMENT_TYPES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case DocumentTypesTypes.FETCH_DOCUMENT_TYPES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case DocumentTypesTypes.FETCH_DOCUMENT_TYPES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case DocumentTypesTypes.FETCH_DOCUMENT_TYPE_REQUEST: {
      return state.setIn(['updateDocumentType', 'isLoading'], true)
    }

    case DocumentTypesTypes.FETCH_DOCUMENT_TYPE_SUCCESS: {
      return state
        .setIn(['updateDocumentType', 'isLoading'], false)
        .setIn(
          ['updateDocumentType', 'data'],
          fromJS(action.payload).delete('streetType').delete('id'),
        )
    }

    case DocumentTypesTypes.FETCH_DOCUMENT_TYPE_FAILURE: {
      return state.setIn(['updateDocumentType', 'isLoading'], false)
    }

    case DocumentTypesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case DocumentTypesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
